import { download } from 'gyl-common/components/Donwloader/hocs/downloadPanelHoc'

export default download
